/**
 * Story 061 — TanStack Query keys for the components feature.
 */
import type { ListComponentsParams } from "./types.js";

export const componentsKeys = {
  all: ["components"] as const,
  lists: () => [...componentsKeys.all, "list"] as const,
  list: (params: ListComponentsParams) =>
    [...componentsKeys.lists(), params] as const,
  detail: (id: string) => [...componentsKeys.all, "detail", id] as const,
};
